import React, { useState, useEffect } from 'react';

interface ApiStatusIndicatorProps {
  apiUrl?: string;
  serviceName?: string;
}

export const ApiStatusIndicator: React.FC<ApiStatusIndicatorProps> = ({ 
  apiUrl = '', 
  serviceName = 'API' 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Mostrar el indicador solo si hay problemas de conectividad
    const hasConnectionIssues = !navigator.onLine || apiUrl.includes('localhost');
    setIsVisible(hasConnectionIssues);
  }, [apiUrl]);

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      backgroundColor: '#ff9800',
      color: 'white',
      padding: '8px 12px',
      borderRadius: '4px',
      fontSize: '12px',
      zIndex: 1000,
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    }}>
      ⚠️ {serviceName} no disponible
      <button 
        onClick={() => setIsVisible(false)}
        style={{
          marginLeft: '8px',
          background: 'none',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          fontSize: '12px'
        }}
      >
        ✕
      </button>
    </div>
  );
};